import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function WhoIsForSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const forItems = ['Personas que viven en pisos pequeños con balcón o ventana', 'Personas cansadas de pagar precios absurdos por vegetales de baja calidad', 'Principiantes absolutos que creen que matan hasta un cactus', 'Buscadores de una vida más sostenible y consciente sin mudarse al campo'];
  const notForItems = ['Personas con grandes terrenos o jardines (esto es para micro-espacios)', 'Quienes buscan sistemas de hidroponía complejos y costosos', 'Aquellos que no están dispuestos a meter las manos en la tierra 10 minutos a la semana'];
  return <section ref={ref} className="w-full py-10 md:py-16 bg-gray-50" data-id="element-216">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-217">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-218">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#2D6A4F] mb-3" data-id="element-219">
            ¿Es Esto Para Ti?
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-220">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white rounded-2xl p-6 border-2 border-[#52B788]" data-id="element-221">
            <h3 className="font-heading text-lg font-bold text-[#2D6A4F] mb-4 flex items-center gap-2" data-id="element-222">
              <CheckCircle2Icon className="w-5 h-5" data-id="element-223" />
              Esto es para ti si...
            </h3>
            <ul className="space-y-3" data-id="element-224">
              {forItems.map((item, index) => <li key={index} className="flex gap-2" data-id="element-225">
                  <CheckCircle2Icon className="w-4 h-4 text-[#40916C] flex-shrink-0 mt-0.5" data-id="element-226" />
                  <span className="text-sm text-gray-700" data-id="element-227">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-white rounded-2xl p-6 border-2 border-gray-200" data-id="element-228">
            <h3 className="font-heading text-lg font-bold text-gray-700 mb-4 flex items-center gap-2" data-id="element-229">
              <XCircleIcon className="w-5 h-5" data-id="element-230" />
              NO es para ti si...
            </h3>
            <ul className="space-y-3" data-id="element-231">
              {notForItems.map((item, index) => <li key={index} className="flex gap-2" data-id="element-232">
                  <XCircleIcon className="w-4 h-4 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-233" />
                  <span className="text-sm text-gray-600" data-id="element-234">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}